/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const accountRouter = {
  path: '/h7',
  component: Layout,
  name: 'menu.name.h7.declaration',
  meta: { title: 'menu.name.h7.declaration', icon: 'clipboard' },
  alwaysShow: true,
  children: [
    {
      path: 'batch',
      component: () => import('@/views/h7/batch/index'),
      name: 'Batch',
      meta: { title: 'Batch', noCache: true }
    },
    {
      path: 'role-add',
      component: () => import('@/views/account/role/add'),
      name: 'AddRole',
      hidden: true,
      meta: { title: 'AddRole', noCache: true }
    },
    {
      path: 'declaration',
      component: () => import('@/views/h7/declaration/index'),
      name: 'Declaration',
      meta: { title: 'Declaration', noCache: true }
    },
    {
      path: 'declaration-detail',
      component: () => import('@/views/h7/declaration/detail'),
      name: 'DeclarationDetail',
      hidden: true,
      meta: { title: 'DeclarationDetail', noCache: true, activeMenu: '/h7/declaration' }
    }
  ]
}
export default accountRouter
